import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { dark, main } = theme.palette.primary;

  return {
    searchInputBase: {
      display: "flex",
      marginBottom: 10,
      paddingRight: 22
    },
    searchInput: {
      padding: "0 16px 0 0",
      height: 50,
      fontSize: 14,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        height: 40
      }
    },
    searchIcon: {
      color: dark,
      fontSize: 18
    },
    clearSearchIcon: {
      color: main
    },
    searchResults: {
      height: "calc(100dvh - 436px)",
      overflow: "auto",
      margin: "0 0 0 -12px",
      [theme.breakpoints.down(Breakpoints.SX_720)]: {
        height: "calc(100dvh - 322px)"
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        height: "calc(100dvh - 236px)"
      },
      [theme.heightBreakpoints.down(400)]: {
        height: "auto"
      }
    },
    horseSummaryRoot: {
      height: 104,
      "& span": {
        height: "100%"
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        height: "auto"
      }
    },
    horseSummaryInfo: {
      height: "100%",
      justifyContent: "space-around",
      "& div": {
        fontSize: 16
      },
      "& div:first-Child": {
        fontSize: 18
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        "& div, div:first-Child": {
          fontSize: 14
        }
      }
    },
    disabledSummary: {
      color: dark
    },
    noContent: {
      height: "auto",
      paddingTop: "25%"
    }
  };
});
